import { WorkspaceUser } from 'features/globalSetup/types/workspaceUser'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_USER } from './api/query'
import { Data, Variables } from './api/types'
import { UseGetWorkspaceUser, UseGetWorkspaceUserProps } from './types'

export const useGetWorkspaceUser = ({ id }: UseGetWorkspaceUserProps): UseGetWorkspaceUser => {
  const { data, isLoading } = useQuery<Variables, Data, undefined | WorkspaceUser>({
    options: {
      enabled: id !== undefined,
      select: ({ node }: Data): undefined | WorkspaceUser => (node ? fromDTO(node) : undefined),
    },
    query: GET_WORKSPACE_USER,
    variables: {
      id: id!,
    },
  })

  return {
    loading: isLoading,
    user: data,
  }
}
